// MOCK DATA — replace with API later
export const CONTACT = {
  phone: "+30 6983400353",
  phoneRaw: "306983400353",
  email: "infoalohatransfers@gmail.com",
  paypal: "https://www.paypal.com/paypalme/ledionhabilaj",
  whatsapp: "https://wa.me/306983400353?text=Hello%20Aloha%20Corfu%20Transfers%2C%20I%20would%20like%20information%20about%20a%20transfer.",
};

export const IMG = {
  hero: "https://images.unsplash.com/photo-1633013980214-95bbfe6427df?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  tours: "https://images.unsplash.com/photo-1682197289142-424218d0cd7c?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  westCoast: "https://images.unsplash.com/photo-1630923933195-3af19c5ff98b?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  oldTown: "https://images.unsplash.com/photo-1651436006266-9798cdb9d19f?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  sunset: "https://images.unsplash.com/photo-1697964332226-581da3cd26f3?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  fleet: "https://images.unsplash.com/photo-1592309905620-e5b59f6dcb98?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  airport: "https://images.unsplash.com/photo-1436491865332-7a61a109cc05?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  port: "https://images.unsplash.com/photo-1594165368909-7f0a32577095?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
};

// [name, tag, type, areaKey, alias?]
const L = [
  // Airport & ports
  ["Corfu International Airport (CFU)", "Airport", "airport", "airport", "kerkyra ioannis kapodistrias"],
  ["Αεροδρόμιο, Γαρίτσα, Μαντούκι", null, "place", "airport", "corfu airport cfu"],
  ["Corfu New Port (Ferry Terminal)", "Port", "port", "port", "ferry kerkyra"],
  ["Corfu Old Port", "Port", "port", "port", "ferry"],
  ["Corfu Cruise Terminal", "Port", "port", "port", "cruise ship"],
  ["Gouvia Marina", "Marina", "port", "gouvia", "port yacht"],
  ["Benitses Marina", "Marina", "port", "benitses", "port yacht"],
  ["Kassiopi Harbour", "Port", "port", "kassiopi", "boat"],
  ["Lefkimmi Port (Igoumenitsa ferry)", "Port", "port", "lefkimmi", "ferry"],
  // Corfu Town & villages
  ["Corfu Old Town (Liston / Spianada)", "City Centre", "place", "town", "corfu town kerkyra"],
  ["Corfu town, Οικουμενικού Πατριάρχη Αθηναγόρα, Σπηλιά", null, "place", "town", "corfu town"],
  ["San Rocco Square, Corfu Town", "City Centre", "place", "town", "saroko"],
  ["Mon Repos Palace", "Landmark", "place", "town", "corfu town"],
  ["Kanoni (Mouse Island)", "Village", "place", "town", "pontikonisi vlacherna"],
  ["Garitsa", "Area", "place", "town", "corfu town"],
  ["Mandouki", "Area", "place", "port", "corfu town"],
  ["Perama", "Resort", "place", "town"],
  ["Alykes Potamou", "Area", "place", "gouvia"],
  ["Potamos", "Village", "place", "gouvia"],
  ["Kontokali", "Resort", "place", "gouvia"],
  ["Gouvia", "Resort", "place", "gouvia"],
  ["Kommeno", "Resort", "place", "dassia"],
  ["Dassia", "Resort", "place", "dassia"],
  ["Ipsos", "Resort", "place", "ipsos"],
  ["Pyrgi", "Village", "place", "ipsos"],
  ["Agios Markos", "Village", "place", "ipsos"],
  ["Barbati", "Beach", "place", "barbati"],
  ["Nissaki", "Village", "place", "nissaki"],
  ["Kaminaki", "Beach", "place", "nissaki"],
  ["Agni Bay", "Beach", "place", "kalami"],
  ["Kalami", "Village", "place", "kalami"],
  ["Kouloura", "Village", "place", "kalami"],
  ["Agios Stefanos (North East)", "Village", "place", "kalami"],
  ["Avlaki Beach", "Beach", "place", "kassiopi"],
  ["Kassiopi", "Village", "place", "kassiopi"],
  ["Kalamaki Beach", "Beach", "place", "kassiopi"],
  ["Agios Spyridon (North)", "Beach", "place", "kassiopi"],
  ["Acharavi", "Resort", "place", "acharavi"],
  ["Almyros Beach", "Beach", "place", "acharavi"],
  ["Roda", "Resort", "place", "roda"],
  ["Karousades", "Village", "place", "roda"],
  ["Sidari", "Resort", "place", "sidari", "canal d'amour"],
  ["Peroulades (Logas Beach)", "Village", "place", "peroulades", "sunset"],
  ["Avliotes", "Village", "place", "peroulades"],
  ["Agios Stefanos (North West)", "Resort", "place", "agstefanosnw"],
  ["Arillas", "Resort", "place", "arillas"],
  ["Afionas", "Village", "place", "arillas"],
  ["Agios Georgios Pagon", "Beach", "place", "aggeorgiosn"],
  ["Paleokastritsa", "Beach", "place", "paleo", "palaiokastritsa"],
  ["Lakones (Bella Vista)", "Village", "place", "lakones"],
  ["Liapades", "Village", "place", "lakones"],
  ["Doukades", "Village", "place", "lakones"],
  ["Ermones", "Beach", "place", "ermones"],
  ["Vatos", "Village", "place", "ermones"],
  ["Myrtiotissa Beach", "Beach", "place", "glyfada"],
  ["Glyfada Beach", "Beach", "place", "glyfada"],
  ["Pelekas", "Village", "place", "pelekas", "kaiser's throne"],
  ["Kontogialos (Pelekas Beach)", "Beach", "place", "pelekas"],
  ["Sinarades", "Village", "place", "agiosgordios"],
  ["Agios Gordios", "Beach", "place", "agiosgordios"],
  ["Gastouri", "Village", "place", "achilleion"],
  ["Achilleion Palace, Gastouri", "Landmark", "place", "achilleion"],
  ["Kastellani", "Village", "place", "achilleion"],
  ["Agios Ioannis Peristeron", "Village", "place", "benitses"],
  ["Benitses", "Resort", "place", "benitses"],
  ["Moraitika", "Resort", "place", "moraitika"],
  ["Messonghi", "Resort", "place", "moraitika"],
  ["Agios Matheos", "Village", "place", "agmatheos"],
  ["Halikounas Beach", "Beach", "place", "agmatheos", "korission lake"],
  ["Issos Beach", "Beach", "place", "issos"],
  ["Boukari", "Village", "place", "boukari"],
  ["Petriti", "Village", "place", "boukari"],
  ["Agios Georgios Argyrades", "Resort", "place", "aggeorgioss"],
  ["Marathias Beach", "Beach", "place", "aggeorgioss"],
  ["Lefkimmi", "Village", "place", "lefkimmi"],
  ["Kavos", "Resort", "place", "kavos"],
  ["Corfu Golf Club, Ropa Valley", "Landmark", "place", "ermones"],
  ["Aqualand Corfu, Agios Ioannis", "Landmark", "place", "aqualand", "water park"],
  ["Pantokrator Mountain", "Landmark", "place", "kassiopi"],
  ["Old Perithia", "Village", "place", "acharavi"],
  // Hotels
  ["Corfu Palace Hotel", "Hotel", "hotel", "town"],
  ["Cavalieri Hotel, Corfu Town", "Hotel", "hotel", "town"],
  ["Bella Venezia Hotel, Corfu Town", "Hotel", "hotel", "town"],
  ["Arcadion Hotel, Corfu Town", "Hotel", "hotel", "town"],
  ["Siorra Vittoria Boutique Hotel", "Hotel", "hotel", "town"],
  ["Corfu Holiday Palace, Kanoni", "Hotel", "hotel", "town"],
  ["Aeolos Beach Resort, Perama", "Hotel", "hotel", "town"],
  ["Kontokali Bay Resort & Spa", "Hotel", "hotel", "gouvia"],
  ["Grecotel Corfu Imperial, Kommeno", "Hotel", "hotel", "dassia"],
  ["Grecotel Eva Palace, Kommeno", "Hotel", "hotel", "dassia"],
  ["Rodostamo Hotel & Spa, Kommeno", "Hotel", "hotel", "dassia"],
  ["Daphnila Bay Dassia", "Hotel", "hotel", "dassia"],
  ["Ikos Dassia", "Hotel", "hotel", "dassia"],
  ["Ikos Odisia", "Hotel", "hotel", "dassia"],
  ["Dassia Chandris Hotel", "Hotel", "hotel", "dassia"],
  ["Elea Beach Hotel, Dassia", "Hotel", "hotel", "dassia"],
  ["Nissaki Beach Hotel", "Hotel", "hotel", "nissaki", "tui blue atlantica"],
  ["Sunshine Corfu Hotel & Spa, Nissaki", "Hotel", "hotel", "nissaki"],
  ["Kalami Bay Villas", "Villa", "villa", "kalami"],
  ["San Antonio Corfu Resort, Kalami", "Hotel", "hotel", "kalami"],
  ["Kassiopi Bay Hotel", "Hotel", "hotel", "kassiopi"],
  ["Ionian Princess Club Hotel, Acharavi", "Hotel", "hotel", "acharavi"],
  ["Almyros Beach Resort, Acharavi", "Hotel", "hotel", "acharavi"],
  ["Roda Beach Resort & Spa", "Hotel", "hotel", "roda"],
  ["Delfinia Hotels, Sidari", "Hotel", "hotel", "sidari"],
  ["Akrotiri Beach Hotel, Paleokastritsa", "Hotel", "hotel", "paleo"],
  ["Grand Mediterraneo Resort, Ermones", "Hotel", "hotel", "ermones"],
  ["Mayor Pelekas Monastery", "Hotel", "hotel", "pelekas"],
  ["Louis Grand Hotel, Glyfada", "Hotel", "hotel", "glyfada"],
  ["Mayor La Grotta Verde, Agios Gordios", "Hotel", "hotel", "agiosgordios"],
  ["Angsana Corfu, Benitses", "Hotel", "hotel", "benitses"],
  ["MarBella Corfu, Agios Ioannis Peristeron", "Hotel", "hotel", "benitses"],
  ["MarBella Nido Suite Hotel", "Hotel", "hotel", "benitses"],
  ["Domes Miramare, Moraitika", "Hotel", "hotel", "moraitika"],
  ["Messonghi Beach Resort", "Hotel", "hotel", "moraitika"],
  ["Mayor Capo di Corfu, Lefkimmi", "Hotel", "hotel", "lefkimmi"],
];
export const LOCATIONS = L.map(([name, tag, type, key, alias]) => ({ name, tag, type, key, alias }));

// Area pricing: [base fare for cheapest vehicle from airport/town hub, lat, lon]
export const AREAS = {
  town: [36, 39.624, 19.921], port: [30, 39.627, 19.909], airport: [36, 39.602, 19.912],
  gouvia: [42, 39.651, 19.851], dassia: [48, 39.684, 19.838], ipsos: [50, 39.700, 19.836],
  barbati: [58, 39.722, 19.871], nissaki: [62, 39.730, 19.900], kalami: [68, 39.744, 19.932],
  kassiopi: [78, 39.790, 19.920], acharavi: [82, 39.795, 19.810], roda: [82, 39.790, 19.785],
  sidari: [80, 39.790, 19.700], peroulades: [84, 39.790, 19.665], agstefanosnw: [86, 39.762, 19.640],
  arillas: [86, 39.745, 19.655], aggeorgiosn: [80, 39.720, 19.665], paleo: [60, 39.670, 19.708],
  lakones: [62, 39.676, 19.725], ermones: [50, 39.612, 19.778], pelekas: [48, 39.590, 19.825],
  glyfada: [55, 39.596, 19.800], agiosgordios: [56, 39.545, 19.800], achilleion: [45, 39.562, 19.904],
  benitses: [44, 39.546, 19.913], aqualand: [42, 39.596, 19.856], moraitika: [52, 39.483, 19.927],
  agmatheos: [58, 39.490, 19.872], issos: [66, 39.455, 19.930], boukari: [62, 39.460, 19.955],
  aggeorgioss: [72, 39.430, 19.960], lefkimmi: [78, 39.420, 20.070], kavos: [85, 39.385, 20.115],
};
export const AREA_NAMES = {
  town: "Corfu Town / Kanoni / Perama", gouvia: "Gouvia / Kontokali / Alykes", dassia: "Dassia / Kommeno", ipsos: "Ipsos / Pyrgi / Agios Markos",
  barbati: "Barbati", nissaki: "Nissaki / Kaminaki", kalami: "Kalami / Agni / Kouloura", kassiopi: "Kassiopi / Avlaki",
  acharavi: "Acharavi / Almyros", roda: "Roda / Karousades", sidari: "Sidari", peroulades: "Peroulades / Avliotes",
  agstefanosnw: "Agios Stefanos (North West)", arillas: "Arillas / Afionas", aggeorgiosn: "Agios Georgios Pagon",
  paleo: "Paleokastritsa", lakones: "Lakones / Liapades", ermones: "Ermones / Vatos / Ropa Valley", pelekas: "Pelekas",
  glyfada: "Glyfada / Myrtiotissa", agiosgordios: "Agios Gordios / Sinarades", achilleion: "Gastouri / Achilleion",
  benitses: "Benitses / Agios Ioannis Peristeron", aqualand: "Agios Ioannis (Aqualand)", moraitika: "Moraitika / Messonghi",
  agmatheos: "Agios Matheos", issos: "Issos / Korission", boukari: "Boukari / Petriti", aggeorgioss: "Agios Georgios Argyrades / Marathias",
  lefkimmi: "Lefkimmi", kavos: "Kavos",
};
export const FARES = Object.fromEntries(Object.entries(AREAS).map(([k, v]) => [k, v[0]]));

export const POPULAR_ROUTES = [
  { to: "Corfu Town", dest: "Corfu Old Town (Liston / Spianada)", price: 36 },
  { to: "Gouvia", dest: "Gouvia", price: 42 },
  { to: "Benitses", dest: "Benitses", price: 44 },
  { to: "Achilleion / Gastouri", dest: "Achilleion Palace, Gastouri", price: 45 },
  { to: "Dassia", dest: "Dassia", price: 48 },
  { to: "Ipsos", dest: "Ipsos", price: 50 },
];

export const FLEET = [
  {
    id: "suv", name: "Premium SUV", model: "Peugeot 5008 or similar",
    image: "https://customer-assets-agu9un31.emergentagent.net/job_corfu-transfers-app/artifacts/6vlgeajt_1a079ca15ef2484eadcea8018187115b.jpg",
    pax: "1–3", paxText: "1–3 passengers", maxPax: 3, bags: 4, bagsText: "Up to 4 bags", from: 36, add: 0,
    features: ["VIP private chauffeur", "Extra comfort & legroom", "Priority routing", "Discreet luxury interior"],
  },
  {
    id: "van", name: "Business Van", model: "Peugeot 5008 GT or similar",
    image: "https://customer-assets-agu9un31.emergentagent.net/job_corfu-transfers-app/artifacts/faxynf5n_PEUGEOT_5008.webp",
    pax: "4–7", paxText: "4–7 passengers", maxPax: 7, bags: 7, bagsText: "Up to 7 bags", from: 49, add: 13,
    features: ["Ideal for families & groups", "Extra large luggage space", "Child seats on request", "Panoramic AC & leather seating"],
  },
  {
    id: "minibus", name: "Group Minibus", model: "Mercedes-Benz Tourer or similar",
    image: "https://static.prod-images.emergentagent.com/jobs/56685c12-55b9-4912-a1dc-17ce41fe4ccb/images/224e64e0de8728ae229e7381558a7ff1d3c274f9f0d7a2997adaf29caddcd8a5.jpeg",
    pax: "8", paxText: "Up to 8 passengers", maxPax: 8, bags: 8, bagsText: "Up to 8 bags", from: 54, add: 18,
    features: ["Seats up to 8 passengers", "Generous luggage capacity", "Perfect for larger groups", "Air-conditioned, high-roof comfort"],
  },
];

export const TESTIMONIALS = [
  { quote: "Excellent service from the airport to our villa. Our driver was friendly, professional and right on time.", name: "Sarah M.", country: "United Kingdom" },
  { quote: "Very easy booking and a smooth transfer. Would definitely use Aloha again.", name: "Michael R.", country: "Germany" },
  { quote: "Spotless Mercedes, calm driver and a warm welcome after a long flight. Exactly what we needed.", name: "Elena P.", country: "Italy" },
  { quote: "Booked a full-day chauffeur for our anniversary. Flawless from start to finish.", name: "David & Anna", country: "Netherlands" },
];

export const TOURS = [
  { slug: "highlights", title: "Private Corfu Highlights", hours: 5, image: IMG.tours,
    desc: "A relaxed private tour covering the island's unmissable highlights with your own driver-guide, from the Venetian Old Town to panoramic viewpoints and the Achilleion Palace.",
    itinerary: ["Hotel/villa pickup", "Corfu Old Town & Liston", "Achilleion Palace", "Panoramic coastal viewpoints", "Return to your accommodation"], center: [39.62, 19.91] },
  { slug: "west-coast", title: "Paleokastritsa & West Coast", hours: 6, image: IMG.westCoast,
    desc: "Discover Corfu's dramatic west coast — turquoise bays, the Paleokastritsa monastery and the famous hilltop views of Bella Vista.",
    itinerary: ["Hotel/villa pickup", "Paleokastritsa bays & monastery", "Bella Vista viewpoint", "Lakones village", "Return to your accommodation"], center: [39.67, 19.71] },
  { slug: "food", title: "Corfu Old Town & Local Food", hours: 4, image: IMG.oldTown,
    desc: "A walkable, flavour-led afternoon through the UNESCO Old Town with tastings of Corfiot specialities and local wine.",
    itinerary: ["Hotel/villa pickup", "Spianada & Liston", "Old Town food tastings", "Local wine stop", "Return to your accommodation"], center: [39.624, 19.92] },
  { slug: "sunset", title: "Sunset Private Tour", hours: 4, image: IMG.sunset,
    desc: "Chase the golden hour on Corfu's west coast and toast the Ionian sunset from a hand-picked viewpoint.",
    itinerary: ["Afternoon pickup", "Pelekas village", "Kaiser's Throne sunset", "Optional dinner stop", "Return to your accommodation"], center: [39.59, 19.82] },
  { slug: "north-explorer", title: "North Corfu & Kassiopi Explorer", hours: 6, image: IMG.hero,
    desc: "Explore the dramatic northeast coast — the 'Kensington-on-Sea' villas, the pretty harbour of Kassiopi and sweeping views across to the Albanian mountains.",
    itinerary: ["Hotel/villa pickup", "Kalami & Agni bays", "Kassiopi harbour & castle", "Coastal lunch stop", "Return to your accommodation"], center: [39.79, 19.92] },
  { slug: "villages-olive", title: "Corfu Villages & Olive Country", hours: 5, image: IMG.tours,
    desc: "Escape inland to the authentic Corfu of mountain villages, centuries-old olive groves and panoramic hilltop views, with time for a traditional village taverna.",
    itinerary: ["Hotel/villa pickup", "Old Perithia village", "Olive grove & press visit", "Village taverna", "Return to your accommodation"], center: [39.76, 19.87] },
];

export const GUIDE_CATS = ["All", "Best Beaches", "Corfu Town", "Things To Do", "Transportation", "Airport Guide"];

export const ARTICLES = [
  { slug: "10-beaches-corfu", title: "10 Beaches You Should See in Corfu", cat: "Best Beaches", image: IMG.westCoast,
    excerpt: "From turquoise coves to long golden sands — the Corfu beaches worth building a day around.",
    body: ["Corfu's coastline stretches for over 200 km, and each side of the island has a completely different personality.", "On the west coast, Paleokastritsa, Glyfada and Agios Gordios offer dramatic cliffs and golden sand. In the north, Sidari's Canal d'Amour is famous for its sculpted sandstone, while the northeast hides pebbly gems like Kalami, Agni and Barbati with crystal-clear water.", "Tip: west-coast beaches catch the best sunsets — book a private transfer back so you can stay for golden hour."] },
  { slug: "first-time-corfu-mistakes", title: "First Time in Corfu? 5 Mistakes to Avoid", cat: "Things To Do", image: IMG.hero,
    excerpt: "Save time and money with these local tips for first-time visitors to Corfu.",
    body: ["1. Underestimating distances — Corfu's winding roads mean a 40 km trip can take over an hour.", "2. Not pre-booking your airport transfer — taxi queues in high season can be long.", "3. Only staying in one area — the north, west and south are all worth exploring.", "4. Skipping the Old Town in the evening — it's at its most magical after sunset.", "5. Forgetting cash for small tavernas and beach bars."] },
  { slug: "getting-around-corfu", title: "How to Get Around Corfu", cat: "Transportation", image: IMG.hero,
    excerpt: "Buses, taxis, rentals and private transfers — how to move around the island stress-free.",
    body: ["Green KTEL buses connect Corfu Town with most resorts, while blue city buses cover the town and nearby villages.", "Car rental gives freedom but narrow mountain roads and parking in high season can be challenging.", "Private transfers are the most relaxing option for airport and port journeys, day trips and evenings out — fixed prices, no parking, no stress."] },
  { slug: "best-areas-to-stay", title: "Best Areas to Stay in Corfu", cat: "Corfu Town", image: IMG.oldTown,
    excerpt: "Where to base yourself in Corfu depending on your travel style and group.",
    body: ["Corfu Town is perfect for culture, food and nightlife. Gouvia, Dassia and Ipsos offer resort convenience close to the airport.", "Families love the calm waters of the northeast, while couples often choose Paleokastritsa or Agios Stefanos for views and quiet.", "Wherever you stay, we can get you there door-to-door from the moment you land."] },
  { slug: "corfu-airport-guide", title: "Corfu Airport: Everything You Need to Know", cat: "Airport Guide", image: IMG.hero,
    excerpt: "Arrivals, transfers, meet & greet and tips for a smooth landing at Corfu (CFU).",
    body: ["Corfu International Airport 'Ioannis Kapodistrias' (CFU) is just 3 km from Corfu Town.", "After collecting your luggage, exit into the arrivals hall where your Aloha driver will be waiting with a name sign.", "We monitor every flight, so if you're delayed, your driver will be too — at no extra cost."] },
  { slug: "7-days-corfu-itinerary", title: "7 Days in Corfu: The Perfect Itinerary", cat: "Things To Do", image: IMG.westCoast,
    excerpt: "A balanced week combining beaches, culture, food and the island's hidden gems.",
    body: ["Day 1: Arrive & unwind. Day 2: Corfu Old Town. Day 3: Paleokastritsa & west coast.", "Day 4: Beach day in the northeast. Day 5: Achilleion Palace & Kanoni. Day 6: Villages & olive country.", "Day 7: Sunset at Kaiser's Throne before your relaxed transfer to the airport."] },
];

export const SERVICE_PAGES = {
  airport: {
    eyebrow: "Corfu Airport · CFU", title: "From Corfu Airport to Your Door.", image: IMG.airport,
    sub: "Skip the queues and arrive relaxed. Your private driver takes you directly from Corfu Airport to your hotel, villa or destination.",
    cta: "Book Airport Transfer", preset: "Corfu International Airport (CFU)", readyText: "Corfu Airport is pre-selected — just add your destination.",
    title2: "A seamless arrival, every time",
    items: [
      ["plane", "Airport pickup", "We collect you directly from Corfu Airport (CFU) arrivals."],
      ["user", "Meet & greet", "Your driver waits in arrivals holding a name sign."],
      ["radar", "Flight monitoring", "We track your flight and adjust for delays — no extra charge."],
      ["luggage", "Luggage assistance", "Help with bags from the hall to the vehicle."],
      ["car", "Private vehicle", "Your own car — never shared with other passengers."],
      ["clock", "24/7 support", "Reach a real person any time, day or night."],
    ],
  },
  port: {
    eyebrow: "Corfu Port · Cruise & Ferry", title: "From the Port Straight to Your Stay.", image: IMG.port,
    sub: "Cruise, ferry and marina pickups with a friendly driver waiting for you — no taxi queues, no hassle.",
    cta: "Book Port Transfer", preset: "Corfu New Port (Ferry Terminal)", readyText: "Corfu Port is pre-selected — just add your destination.",
    title2: "Stress-free port pickups",
    items: [
      ["anchor", "Ferry & cruise pickup", "We meet you at the New Port, cruise terminal or marina."],
      ["user", "Meet & greet", "Your driver waits at the exit with a name sign."],
      ["radar", "Schedule monitoring", "We follow ferry arrivals and adjust for delays."],
      ["luggage", "Luggage assistance", "Help with bags straight to the vehicle."],
      ["car", "Private vehicle", "Your own car — never shared with other passengers."],
      ["clock", "24/7 support", "Reach a real person any time, day or night."],
    ],
  },
  private: {
    eyebrow: "Island-wide · Door-to-door", title: "Anywhere in Corfu, Privately.", image: IMG.westCoast,
    sub: "Island-wide private transfers between any two points — hotels, villas, beaches, restaurants and more.",
    cta: "Book Private Transfer", preset: "", readyText: "Choose any pickup and destination on the island.",
    title2: "Your island, your way",
    items: [
      ["map", "Any two points", "Hotel to beach, villa to restaurant, town to village."],
      ["tag", "Fixed prices", "Clear, upfront fares with no surprises."],
      ["user", "Professional drivers", "Courteous, licensed and English-speaking."],
      ["baby", "Child seats", "Available on request at no extra cost."],
      ["car", "Private vehicle", "Your own car — never shared with other passengers."],
      ["clock", "24/7 support", "Reach a real person any time, day or night."],
    ],
  },
  chauffeur: {
    eyebrow: "Hourly · Chauffeur service", title: "Your Driver, Your Schedule.", image: IMG.oldTown,
    sub: "Book a private chauffeur by the hour for shopping, dinners, events or exploring Corfu at your own pace.",
    cta: "Book Hourly Chauffeur", preset: "", readyText: "Choose your pickup and how many hours you need.", hourly: true,
    title2: "Flexible, by the hour",
    items: [
      ["clock", "Minimum 3 hours", "Flexible bookings from 3 hours up to a full day."],
      ["map", "Multiple stops", "Go wherever you like — your driver waits for you."],
      ["user", "Local insight", "Drivers happy to suggest hidden gems and great tavernas."],
      ["glass", "Events & occasions", "Weddings, anniversaries and special evenings."],
      ["car", "Premium vehicles", "Immaculate SUVs, vans and minibuses."],
      ["clock", "24/7 support", "Reach a real person any time, day or night."],
    ],
  },
};

export const FAQS = [
  ["How do I find my driver at Corfu Airport?", "Your driver will be waiting in the arrivals hall holding a sign with your name."],
  ["What happens if my flight is delayed?", "We monitor all flights and adjust pickup time automatically at no extra cost."],
  ["Can I pay my driver in cash?", "Yes — you can pay online or directly to your driver in cash or by card."],
  ["Do you provide child seats?", "Yes, child and booster seats are available on request free of charge."],
  ["What is your cancellation policy?", "Free cancellation up to 24 hours before your pickup time."],
  ["Are prices per person or per vehicle?", "All prices are per vehicle, not per person, and include luggage, tolls and taxes."],
];

export const LEGAL = {
  privacy: ["Privacy Policy", "We only collect the personal data needed to deliver your transfer (name, contact details, flight information). We never sell your data and you may request deletion at any time by contacting us."],
  terms: ["Terms & Conditions", "By booking with Aloha Corfu Transfers you agree to provide accurate travel details. Prices are per vehicle and fixed at the time of booking. Waiting time beyond 60 minutes after landing may incur extra charges."],
  cookies: ["Cookie Policy", "We use essential cookies to remember your language and booking preferences. No third-party advertising cookies are used."],
  cancellation: ["Cancellation Policy", "Free cancellation up to 24 hours before pickup. Cancellations within 24 hours are charged 50% of the fare. No-shows are charged in full."],
};

export const nearestArea = (lat, lon) => {
  let best = "town", bd = Infinity;
  Object.entries(AREAS).forEach(([k, [, la, lo]]) => {
    if (k === "airport" || k === "port") return;
    const d = (la - lat) ** 2 + ((lo - lon) * 0.77) ** 2;
    if (d < bd) { bd = d; best = k; }
  });
  return best;
};

const REG_KEY = "aloha_place_registry";
const readReg = () => { try { return JSON.parse(localStorage.getItem(REG_KEY) || "{}"); } catch { return {}; } };
// stores { key, lat, lon } for searched / custom places
export const registerPlace = (p) => {
  const reg = readReg();
  const key = p.key || nearestArea(p.lat, p.lon);
  const [, la, lo] = AREAS[key] || AREAS.town;
  reg[p.name] = { key, lat: p.lat ?? la, lon: p.lon ?? lo };
  localStorage.setItem(REG_KEY, JSON.stringify(reg));
  return key;
};
const regEntry = (name) => {
  const r = readReg()[name];
  return typeof r === "string" ? { key: r } : r;
};
export const areaOf = (name) => {
  if (!name) return undefined;
  const l = LOCATIONS.find((x) => x.name === name);
  if (l) return l.key;
  return regEntry(name)?.key;
};
// "key,lat,lon" string for saving with bookings / sharing in links
export const geoOf = (name) => {
  const k = areaOf(name);
  const c = coordsOf(name);
  return k && c ? `${k},${c[1].toFixed(5)},${c[0].toFixed(5)}` : null;
};
export const registerGeo = (name, geo) => {
  if (!name || !geo || LOCATIONS.some((l) => l.name === name)) return;
  const [key, lat, lon] = geo.split(",");
  if (AREAS[key]) registerPlace({ name, key, lat: Number(lat), lon: Number(lon) });
};

// [lon, lat] for routing
export const coordsOf = (name) => {
  const e = regEntry(name);
  if (e && e.lat !== undefined) return [e.lon, e.lat];
  const k = areaOf(name);
  if (!k) return null;
  const [, la, lo] = AREAS[k];
  return [lo, la];
};

// Pricing rules (edit here). Car always starts at Corfu Airport.
// - Airport / port / Corfu Town  <->  area: fixed area fare (AREAS table)
// - Any other A -> B: BASE + PER_KM x road km of (airport -> pickup -> drop-off), never below the area fares
export const PRICING = { base: 28, perKm: 1.4, roadFactor: 1.73 };
// Areas that must always cost the same as another area (priced using the anchor's distance)
export const PRICE_ANCHOR = { acharavi: "roda" };
const anchorOf = (k) => PRICE_ANCHOR[k] || k;
const HUBS = ["airport", "port", "town"];

const roadKm = (a, b) => {
  const [, la1, lo1] = AREAS[a] || AREAS.town;
  const [, la2, lo2] = AREAS[b] || AREAS.town;
  const dx = (lo2 - lo1) * 111.32 * Math.cos(((la1 + la2) / 2) * Math.PI / 180);
  const dy = (la2 - la1) * 110.57;
  return Math.hypot(dx, dy) * PRICING.roadFactor;
};

export const fareInfo = (pickup, dropoff) => {
  const p = areaOf(pickup), d = areaOf(dropoff);
  if (!p && !d) return { fare: 36, positioned: false };
  if (!p || HUBS.includes(p)) return { fare: FARES[d] || 36, positioned: false };
  if (!d || HUBS.includes(d)) return { fare: FARES[p] || 36, positioned: false };
  const km = roadKm("airport", anchorOf(p)) + roadKm(anchorOf(p), anchorOf(d));
  return { fare: positionedFare(km, p, d), positioned: true, km: Math.round(km), p, d };
};

// fare for A->B trips given real road km (airport -> pickup -> drop-off)
export const positionedFare = (km, p, d) =>
  Math.max(Math.round(PRICING.base + PRICING.perKm * km), FARES[anchorOf(p)] || 0, FARES[anchorOf(d)] || 0);

// routing points [lon,lat] for the trip (includes airport start when positioned)
// pricing=true swaps anchored areas (e.g. Acharavi -> Roda) so they price identically
export const routePoints = (pickup, dropoff, positioned, pricing = false) => {
  const anc = (name) => {
    const k = areaOf(name);
    if (pricing && k && PRICE_ANCHOR[k]) { const [, la, lo] = AREAS[PRICE_ANCHOR[k]]; return [lo, la]; }
    return coordsOf(name);
  };
  const a = anc(pickup), b = anc(dropoff);
  if (!a || !b) return null;
  const [, la, lo] = AREAS.airport;
  return positioned ? [[lo, la], a, b] : [a, b];
};

export const getFare = (pickup, dropoff) => fareInfo(pickup, dropoff).fare;

export const paypalLink = (amount) => {
  const n = Number(amount || 0);
  return `${CONTACT.paypal}/${Number.isInteger(n) ? n : n.toFixed(2)}EUR`;
};

export const vehicleAlt = (v) => `${v.name}${v.model ? ` (${v.model})` : ""} – ${/van|minibus|sprinter|vito|v-class/i.test(`${v.name} ${v.model || ""}`) ? "Corfu private transfer minivan" : "Corfu private transfer car"} and Corfu airport taxi by Aloha Corfu Transfers`;

// Responsive srcset for Unsplash hero images (smaller files on phones).
export const heroSrcSet = (url) => (url && url.includes("w=2000") ? `${url.replace("w=2000", "w=800")} 800w, ${url.replace("w=2000", "w=1400")} 1400w, ${url} 2000w` : undefined);

// Built-in hotels/villas/beaches get an exact map pin (looked up once) instead of the village centre.
export const needsPin = (name) => {
  const l = LOCATIONS.find((x) => x.name === name);
  if (!l || ["airport", "port"].includes(l.key) || ["airport", "port"].includes(l.type)) return false;
  return regEntry(name)?.lat === undefined;
};
export const pinPlace = (name, lat, lon) => {
  const k = areaOf(name);
  const [, la, lo] = AREAS[k] || AREAS.town;
  const km = Math.hypot((lon - lo) * 85.8, (lat - la) * 110.57);
  if (km > 12) return false; // ignore lookups that landed far from the expected area
  registerPlace({ name, key: k, lat, lon });
  return true;
};

export const TOURS_SITE = "https://alohacorfutours.com";

// Editable from Admin → Website texts (defaults below).
export const HOME = {
  heroTitle1: "Arrive in Corfu.", heroTitle2: "Start Your Holiday.",
  heroSub: "Private, comfortable and reliable transfers across Corfu — from the airport and port directly to your hotel, villa or destination.",
  heroAlt: "Corfu coastline – Aloha Corfu Transfers private airport and port transfers in Corfu",
  ctaTitle: "Ready to ride in comfort?", ctaSub: "Book in minutes. Pay online or to your driver. Arrive relaxed.",
  reviewsTitle: "Loved by Travellers to Corfu",
};
export const TOURS_PAGE = {
  title: "Tours & Experiences",
  sub: "Discover Corfu at your own pace with curated private tours and your own driver-guide. Every itinerary is fully customisable.",
};
export const EXTRA_BLOCKS = { __about: {} };
